module.exports = __webpack_public_path__ + "static/media/sow.a44ad4ad.svg";